import {PageCenteredSpinner} from '@/componentLibrary/components/spinners/PageCenteredSpinner';
import {useTriggerSyncData} from '@/pages/User/pages/VerifyLinkedinAuthentication/hooks/useTriggerSyncData';

export const VerifyLinkedinAuthentication = () => {
    useTriggerSyncData();
    return <PageCenteredSpinner />;
};
